import React, { useEffect, useState, useRef } from 'react';
import makeStyles from "@material-ui/styles/makeStyles";
import withStyles from "@material-ui/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from '@material-ui/pickers';
import api from "../../common/api";
import CircularProgress from "@material-ui/core/CircularProgress";
import html2canvas from 'html2canvas';
import moment from "moment";
import { useReactToPrint } from 'react-to-print';
import { useGlobalState } from '../../state';
import Divider from '@material-ui/core/Divider';
import TableWrapper from "../../components/Table/TableWrapper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { version } from "../../common/enums";
import MenuItem from "@material-ui/core/MenuItem";
window.html2canvas = html2canvas;

const useStyles = makeStyles(theme => ({
    root: props => ({
        margin: props.isDesktop ? theme.spacing(1) : theme.spacing(0.5)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
    formControl: {
        width: '100%'
    },
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    progressBar: {
        margin: theme.spacing(2)
    },
    boldedText: {
        fontWeight: 'bold'
    },
}));

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: '1em',
        backgroundColor: theme.palette.common.white,
        padding: '6px'
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
}))(TableRow);

// Feed (materialTypeId 5) keeps its own report endpoint; Medicine /
// Vaccination share the medicine storage report.
const FEED_TYPE_ID = 5;

const generateExcel = function (header, data) {
    let csvData = '';
    header.forEach((column, index) => {
        csvData = index === 0 ? csvData + column : csvData + ',' + column;
    });
    csvData = csvData + '\r\n';
    data.forEach(row => {
        csvData = csvData + `${row[0]},${row[1] !== "0" ? moment(row[1]).format("DD-MM-YYYY") : ""},${row[2] !== "0" ? moment(row[2]).format("DD-MM-YYYY") : ""},${row[3]},${row[4]},${row[5]},${row[6]} \r\n`;
    });

    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData));
    element.setAttribute('download', 'storage-report.csv');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

const StorageReport = function ({ showError, match }) {
    const theme = useTheme();
    const farmID = match.params['farmID'];
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [valid, setValid] = useState(false);
    const [data, setData] = useState([]);
    const [wholedata, setWholeData] = useState([]);
    const [invoiceSetting, setInvoiceSetting] = useState({});

    const [MaterialList, setMaterialList] = useState(null);
    const [MaterialTypeList, setMaterialTypeList] = useState(null);
    const [materialTypeIdx, setMaterialTypeIdx] = useState("");
    const [materialStockTypeIdx, setMaterialStockTypeIdx] = useState("");

    useEffect(() => {
        if (startDate && endDate && (startDate.getTime() < endDate.getTime()) && materialTypeIdx !== "" && materialStockTypeIdx !== "") {
            setValid(true);
        } else {
            setValid(false);
        }
    }, [startDate, endDate, materialStockTypeIdx, materialTypeIdx]);

    const getAllInvoiceSettings = () => {
        if (user.versionID === version.proPlus) { // only for pro plus
            showError('');
            const response = api.get('invoiceSettings');
            response.then(res => {
                setInvoiceSetting(res[0]);
            }).catch(err => {
                if (err.message) {
                    if (err.message === 'Bad Request' || err.message === 'No data found')
                        showError('No InvoiceSettings Found');
                    else
                        showError(err.message);
                } else {
                    showError('Unknown Error');
                }
            });
            return response;
        }
    };

    const onLoad = () => {
        setLoading(true);
        Promise.all([getAllInvoiceSettings(), getMaterialTypes()]).finally(() => {
            setLoading(false);
        });
    };

    useEffect(onLoad, []);

    // Material types: Medicine + Vaccination (material-type) and Feed (feed list)
    const getMaterialTypes = () => {
        showError('');
        const medicineReq = api.get(`material-type`);
        const feedReq = api.post(`/feed-stock/get-feed-list/${farmID}`, {});

        return Promise.allSettled([medicineReq, feedReq]).then(([medRes, feedRes]) => {
            const materialTypes = [];
            const list = {};

            if (medRes.status === 'fulfilled' && medRes.value) {
                const res = medRes.value;
                if (res.Medicine) {
                    materialTypes.push({ key: 0, value: res.Medicine[0].materialTypeId, type: res.Medicine[0].type });
                    list.Medicine = res.Medicine;
                }
                if (res.Vaccination) {
                    materialTypes.push({ key: 1, value: res.Vaccination[0].materialTypeId, type: res.Vaccination[0].type });
                    list.Vaccination = res.Vaccination;
                }
            }

            const feedArr = feedRes.status === 'fulfilled' && feedRes.value && Array.isArray(feedRes.value.Feed)
                ? feedRes.value.Feed : [];
            materialTypes.push({ key: 2, value: FEED_TYPE_ID, type: 'Feed' });
            list.Feed = feedArr;

            setMaterialTypeList(materialTypes);
            setMaterialList(list);
        });
    };

    const handlematerialChange = (event) => {
        setMaterialTypeIdx(event.target.value);
        setMaterialStockTypeIdx("");
    };

    const parseReportFromServer = function (data) {
        const { reportsArray } = data;
        setData(reportsArray !== null && reportsArray !== undefined ? reportsArray : []);
        setWholeData(data);
    };

    const generateReport = function () {
        showError('');
        setLoading(true);
        const selectedType = MaterialTypeList[materialTypeIdx];
        const materials = MaterialList[selectedType.type];
        const payload = {
            startDate: startDate,
            endDate: endDate,
            materialType: selectedType.type,
            materialMasterId: materials[materialStockTypeIdx].materialMasterId,
            materialName: materials[materialStockTypeIdx].materialName,
            farmID: parseInt(farmID)
        };

        const reportApi = selectedType.value === FEED_TYPE_ID
            ? `reports/feed-storage-report/${farmID}`
            : `reports/medicine-storage-report/${farmID}`;

        const response = api.post(reportApi, payload);

        response.then(res => {
            parseReportFromServer(res);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError(err.message);
            } else {
                showError('Unknown Error');
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop });

    const componentRef = useRef();
    const generatePDF = useReactToPrint({
        content: () => componentRef.current,
    });
    const [{ user }] = useGlobalState();
    const amountObj = {
        style: "currency",
        currency: user.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };

    const selectedType = MaterialTypeList && materialTypeIdx !== "" ? MaterialTypeList[materialTypeIdx] : null;
    const nameLabel = selectedType && selectedType.value === FEED_TYPE_ID ? 'Feed Name' : 'Medicine Name';
    const reportTitle = selectedType && selectedType.value === FEED_TYPE_ID ? 'Feed Storage Report' : 'Storage Report';
    const tableHeader = [[nameLabel, "Movement Date", "Purchase Date", "Quantity In", "In Rate", "Quantity Out", "Out Rate"]];

    return <div className={classes.root}>
        <Grid
            container
            alignItems='flex-start'
            className={classes.topBar}
        >
            <Grid>
                <Typography display="block" variant="h5" gutterBottom>
                    Storage Report - {window.localStorage.getItem("farmName")}
                </Typography>
            </Grid>
        </Grid>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container
                spacing={3}
                justify="flex-start"
                alignItems="center">

                <Grid item>
                    <KeyboardDatePicker
                        margin="normal"
                        autoOk
                        variant="inline"
                        label="From"
                        format="dd/MM/yyyy"
                        value={startDate}
                        onChange={(date) => setStartDate(date)}
                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                    />
                </Grid>
                <Grid item>
                    <KeyboardDatePicker
                        margin="normal"
                        variant="inline"
                        autoOk
                        label="To"
                        format="dd/MM/yyyy"
                        value={endDate}
                        onChange={(date) => setEndDate(date)}
                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                    />
                </Grid>
                <Grid item>
                    <FormControl style={{ minWidth: "150px" }} className={classes.formControl}>
                        <InputLabel id="type-select-outlined-label">
                            Material Type
                        </InputLabel>
                        <Select
                            id="materialType"
                            value={materialTypeIdx}
                            onChange={(e) => { handlematerialChange(e); }}
                            name="materialTypeIdx"
                        >
                            {Array.isArray(MaterialTypeList)
                                ? MaterialTypeList.map((material, idx) => (
                                    <MenuItem key={material.key} value={idx}>
                                        {material.type}
                                    </MenuItem>
                                ))
                                : ""}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl style={{ minWidth: "150px" }} className={classes.formControl}>
                        <InputLabel id="type-select-outlined-label">
                            Material Name
                        </InputLabel>
                        <Select
                            id="materialName"
                            value={materialStockTypeIdx}
                            onChange={(e) => setMaterialStockTypeIdx(e.target.value)}
                            name="materialStockTypeIdx"
                        >
                            {MaterialList !== undefined &&
                            MaterialList !== null &&
                            MaterialList[MaterialTypeList[materialTypeIdx]?.type] !== undefined &&
                            MaterialList[MaterialTypeList[materialTypeIdx]?.type] !== null
                                ? MaterialList[MaterialTypeList[materialTypeIdx]?.type].map((material, index) => (
                                    <MenuItem key={material.id} value={index}>
                                        {material.materialName}
                                    </MenuItem>
                                ))
                                : ""}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item>
                    <Button disabled={!valid} variant="contained" color="primary"
                        onClick={generateReport}>Generate</Button>
                </Grid>
                <Grid item>
                    <Button disabled={!valid || data.length < 1} variant="outlined" color="primary"
                        onClick={generatePDF} endIcon={<PictureAsPdfIcon />}>Download PDF</Button>
                </Grid>
                <Grid item>
                    <Button disabled={!valid || data.length < 1} variant="outlined" color="primary"
                        onClick={() => generateExcel(tableHeader[0], data)}
                        endIcon={<GetAppIcon />}>Download Excel</Button>
                </Grid>
            </Grid>
        </MuiPickersUtilsProvider>

        {loading ?
            <div className={classes.progressContainer}>
                <CircularProgress className={classes.progressBar} />
            </div>
            :
            <div id="customer-invoice" ref={componentRef} style={{ paddingTop: '35px' }}>
                <div className="invoice-box" style={{
                    backgroundColor: '#ffffff',
                    padding: isDesktop ? "50px" : "10px",
                    fontFamily: 'Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif'
                }}>
                    <table cellPadding="0" cellSpacing="0">
                        <tbody>
                            <tr>
                                <td>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                {
                                                                    user.versionID === version.proPlus ?
                                                                        <td style={{ width: "40%" }}><img src={invoiceSetting.companyLogo}
                                                                            style={{ maxWidth: '130px' }}
                                                                            alt="company logo"></img><br /><br />
                                                                        </td> : ""
                                                                }
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    <table style={{ width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ textAlign: "right", fontWeight: '600', fontSize: '23px' }} colSpan="2">
                                                                    {reportTitle}<br />
                                                                    <span style={{ fontWeight: '400', fontSize: '15px' }}>
                                                                        <b>From : </b> {moment(startDate).format('MMM Do YYYY')}
                                                                    </span><br />
                                                                    <span style={{ fontWeight: '400', fontSize: '15px' }}>
                                                                        <b>To : </b> {moment(endDate).format('MMM Do YYYY')}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">
                                                                    <Divider />
                                                                    <br />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ textAlign: "right" }}>
                                                                    Opening Stock
                                                                </td>
                                                                <td style={{ textAlign: "right" }}>
                                                                    {wholedata.openingStock !== undefined ? wholedata.openingStock : 0}
                                                                </td>
                                                            </tr>
                                                            <tr style={{ fontWeight: 'bold' }}>
                                                                <td style={{ textAlign: "right" }}>
                                                                    Closing Stock
                                                                </td>
                                                                <td style={{ textAlign: "right" }}>
                                                                    {wholedata.closingStock !== undefined ? wholedata.closingStock : 0}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <TableWrapper enableKeyboardNavigation={true} focus={data && data.length > 0}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>{nameLabel}</StyledTableCell>
                                    <StyledTableCell>Movement Date</StyledTableCell>
                                    <StyledTableCell>Purchase Date</StyledTableCell>
                                    <StyledTableCell>In Quantity</StyledTableCell>
                                    <StyledTableCell>In Rate</StyledTableCell>
                                    <StyledTableCell>Out Quantity</StyledTableCell>
                                    <StyledTableCell>Out Rate</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row, index) => (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell align="left">
                                            {row[0]}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            {row[1] !== "0" ? moment(row[1]).format("DD-MM-YYYY") : ""}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            {row[2] !== "0" ? moment(row[2]).format("DD-MM-YYYY") : ""}
                                        </StyledTableCell>
                                        <StyledTableCell className={
                                            row[0].includes('Net')
                                                ? classes.boldedText : undefined
                                        } align="left"> {row[3] !== "" ? parseFloat(row[3]) : ""}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            {row[4] !== "" ? parseFloat(row[4]).toLocaleString(user.locales, amountObj) : ""}
                                        </StyledTableCell>
                                        <StyledTableCell className={
                                            row[0].includes('Net')
                                                ? classes.boldedText : undefined
                                        } align="left"> {row[5] !== "" ? parseFloat(row[5]) : ""}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">
                                            {row[6] !== "" ? parseFloat(row[6]).toLocaleString(user.locales, amountObj) : ""}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableWrapper>
                </div>
            </div>
        }
    </div>;
};

export default StorageReport;
